module.exports = __webpack_public_path__ + "static/man-7abf4f7279d9d4e3f30d94f64a19c561.png";